import { forwardRef, type Ref, type SVGProps } from "react";
const IconLockClosedOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M25 14h-2V8a6 6 0 0 0-6-6h-2a6 6 0 0 0-6 6v6H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2M11 8a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v6H11Zm14 20H7V16h18Z" />
    <path d="M17 22.28V19a1 1 0 0 0-2 0v3.28A2 2 0 0 0 14 24a2 2 0 0 0 4 0 2 2 0 0 0-1-1.72" />
  </svg>
);
const ForwardRef = forwardRef(IconLockClosedOutlineSVG);
ForwardRef.displayName = "IconLockClosedOutline";
export { ForwardRef as IconLockClosedOutline };
